import { Flex, Text, Box, Button } from "@shared/primitive-components"
import { AddedFleetEntry } from "../../../../../api/fleet"
import { AddFleetEntryFormError } from "../../../types"
import * as styles from "./styles"

export const CSV_ERRORS_DTI = {
  FINISH: `csv_errors_finish`,
}

export type CSVErrorsProps = {
  rows: ReadonlyArray<Partial<AddedFleetEntry>>
  errors: ReadonlyArray<AddFleetEntryFormError>
  dataTestId?: string
  onFinish: () => void
}

export const CSVErrors = ({ rows, errors, dataTestId, onFinish }: CSVErrorsProps) => (
  <Flex flexDirection="column" data-testid={dataTestId}>
    <Text css={styles.marginBottom}>We were unable to process your csv file as it might have some issues.</Text>
    <Text>Please have another look at the file you uploaded to make sure that it looks right.</Text>
    <Box css={styles.contentWrap} />
    {errors.map((error, i) => (
      <Flex key={`line_${i}`}>
        <Text>{`Error for reg ${rows[i]?.registrationNumber || `Unknown`}: ${Object.values(error)
          .filter((it) => !!it)
          .join(`,`)}`}</Text>
      </Flex>
    ))}
    <Flex css={styles.buttonsWrap}>
      <Button onClick={onFinish} data-testid={CSV_ERRORS_DTI.FINISH}>
        Finish
      </Button>
    </Flex>
  </Flex>
)

CSVErrors.defaultProps = {
  dataTestId: undefined,
}
